const state = {
  selectedComments: {},
  comments: {
    'ModelAdminDown': {
      '1-1 Down': {
        '2020': {
          'jan':
          {
            title: 'Jan 2019 | 1-1 Down',
            comments: [
              { id: '1', text: 'This is a comment in january', user: 'Ash R.', time: '03/20/2020 08:15:55 AM' },
              { id: '2', text: 'This is a second comment in january', user: 'Matthew W.', time: '03/22/2020 10:36:39 AM' },
              { id: '3', text: 'This is a fab comment in january', user: 'Brandi S.', time: '03/26/2020 12:56:39 PM' }
            ],
            resolved: false
          },
          'mar':
          {
            title: 'Mar 2020 | 1-1 Down',
            comments: [
              { id: '1', text: 'This is a comment in march', user: 'Ash R.', time: '03/20/2020 08:15:55 AM' },
              { id: '2', text: 'This is a second comment in march', user: 'Matthew W.', time: '03/22/2020 10:36:39 AM' },
              { id: '3', text: 'This is a fab comment in march', user: 'Brandi S.', time: '03/26/2020 12:56:39 PM' }
            ],
            resolved: true
          }
        }
      }
    },
    'RentalIncome': {
      '4100 - Gross potential rent': {
        '2020': {
          'jan':
          {
            title: 'Jan 2019 | 4100 - Gross potential rent',
            comments: [
              { id: '1', text: 'This is a comment in january', user: 'Ash R.', time: '03/20/2020 08:15:55 AM' },
              { id: '2', text: 'This is a second comment in january', user: 'Matthew W.', time: '03/22/2020 10:36:39 AM' },
              { id: '3', text: 'This is a fab comment in january', user: 'Brandi S.', time: '03/26/2020 12:56:39 PM' }
            ],
            resolved: false
          },
          'mar':
          {
            title: 'Mar 2020 | 4100 - Gross potential rent',
            comments: [
              { id: '1', text: 'This is a comment in march', user: 'Ash R.', time: '03/20/2020 08:15:55 AM' },
              { id: '2', text: 'This is a second comment in march', user: 'Matthew W.', time: '03/22/2020 10:36:39 AM' },
              { id: '3', text: 'This is a fab comment in march', user: 'Brandi S.', time: '03/26/2020 12:56:39 PM' }
            ],
            resolved: true
          }
        }
      }
    }
  }
}

const getters = {
  comments: (state) => state.comments,
  selectedComments: (state) => state.selectedComments,
  hasSelectedComments: (state) => Boolean(state.selectedComments.comments)
}

const actions = {
  changeComments({ commit }, comments) {
    commit('setComments', comments)
  },
  changeSelectedComments({ commit }, selectedComments) {
    commit('setSelectedComments', selectedComments)
  },
  clearSelectedComments({ commit }) {
    commit('setSelectedComments', {})
  }
}

const mutations = {
  setComments: (state, comments) => (state.comments = comments),
  setSelectedComments: (state, selectedComments) => state.selectedComments = selectedComments
}

export default {
  state,
  getters,
  actions,
  mutations
}
